<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PFormationSectionBanche'
});
</script>
<template>
  <ka-container
    code="p-formation-section-banche"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Section -->
    <ka-container code="section">
      <!-- Container -->
      <ka-container code="container">
        <ka-text code="titre">
          <h3 v-html="componentInstance.$title.value" />
        </ka-text>
        <ka-text
          code="text"
          :value="componentInstance.$paragraph.value" />
      </ka-container>
      <ka-image
        code="image"
        :options="{
          animationIn: `fadeIn`,
          lazyOptions: {
            throttle: 200,
            once: true,
            intersection: { threshold: 0.1 }
          },
          imgFit: `cover`,
          alt: componentInstance.$seoImage.value + `Image`
        }"
        :xs="{ hidden: null }"
        :value="componentInstance.$picture.value" />
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pFormationSectionBancheComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c27')
const component = pFormationSectionBancheComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  paragraph?: Nullable<string>
  title?: Nullable<string>
  picture?: Nullable<string | File>
  seoImage?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  paragraph: '',
  title: '',
  picture: undefined,
  seoImage: undefined,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:paragraph',
  'update:title',
  'update:picture',
  'update:seoImage'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    paragraph: true,
    title: true,
    picture: true,
    seoImage: true
  }
})
</script>
